import React from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { useInputFullName } from "../NamePrefixContext";
import SubForm from "../SubForm";
import { ArraySubFormContext } from "./ArraySubFormContext";
import { singleGridItem } from "../../defaultStyles";
import { Grid2 as Grid, Grid2Props } from "@mui/material";

interface ArraySubFormProviderProps extends Grid2Props {
  name: string;
  children?: React.ReactNode;
}

const ArraySubFormProvider = ({
  name,
  children,
  ...grid
}: ArraySubFormProviderProps) => {
  const { control } = useFormContext();

  const fullName = useInputFullName(name);

  const { fields, append, remove } = useFieldArray({
    control,
    name: fullName,
  });

  return (
    <SubForm name={name}>
      <ArraySubFormContext.Provider
        value={{
          fields,
          append,
          remove,
        }}
      >
        <Grid container spacing={1} {...singleGridItem} {...grid}>
          {children}
        </Grid>
      </ArraySubFormContext.Provider>
    </SubForm>
  );
};

export default ArraySubFormProvider;
